<script>
    import { apiMethods } from "../../Services/index.svelte";
    import {
        CardLayout,
        ErrorModal,
    } from "../../Components/Common/index.svelte";

    import {
        PageHead,
        PasswordInput,
        Button,
    } from "../../Components/Common/index.svelte";
    import {
        getEmailValidation,
        getPhoneValidation,
        goBack,
        goToURL,
        showError,
        showException,
    } from "../../Utils/utilFunctions.svelte";

    let newAdmin = {
        status: Number(0),
        loginAttempts: Number(0),
        roles: [{ role: Number(100), name: "Admin" }],
    };

    $: CreateButtonDisabled = _checkCreateButtonDisable(
        newAdmin,
        isValidEmail,
        isValidPhone,
    );

    $: isValidEmail = newAdmin.email
        ? getEmailValidation(newAdmin.email)
        : true;

    $: isValidPhone = newAdmin.phone
        ? getPhoneValidation(newAdmin.phone)
        : true;

    const createAdmin = () => {
        newAdmin.fullName = newAdmin.firstName + " " + newAdmin.lastName;
        newAdmin.createdDate = new Date().toISOString();
        newAdmin.updatedDate = new Date().toISOString();

        apiMethods.postMethod
            .createAdmin(newAdmin)
            .then((res) => {
                if (res.id) {
                    delete newAdmin.firstName;
                    delete newAdmin.lastName;
                    delete newAdmin.confirmPassword;
                    delete newAdmin.email;
                    delete newAdmin.phone;
                    delete newAdmin.password;
                    goToURL(`/Admin/view/${res.id}`);
                } else {
                    showError(res.error);
                }
            })
            .catch((err) => showException(err));
    };

    // HELPER FUNCTIONS
    const _checkCreateButtonDisable = (
        newAdmin,
        isValidEmail,
        isValidPhone,
    ) => {
        return (
            !newAdmin.firstName ||
            !newAdmin.lastName ||
            !newAdmin.email ||
            !newAdmin.phone ||
            !newAdmin.password ||
            !newAdmin.confirmPassword ||
            !isValidEmail ||
            !isValidPhone ||
            newAdmin.password !== newAdmin.confirmPassword
        );
    };
</script>

<PageHead title="Create New Admin" />

<CardLayout title="Admin Details">
    <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
        <div class="flex flex-col flex-1 gap-y-4 h-auto">
            <div class="flex gap-x-4 items-center align-center">
                <label class="w-1/3 text-right" for="firstName"
                    >First Name</label
                >
                <input
                    type="text"
                    required
                    class="input input-bordered input-sm flex flex-1"
                    id="firstName"
                    name="firstName"
                    bind:value={newAdmin.firstName}
                />
            </div>

            <div class="flex gap-x-4 items-center align-center">
                <label class="w-1/3 text-right" for="lastName">Last Name</label>
                <input
                    type="text"
                    required
                    class="input input-bordered input-sm flex flex-1"
                    id="lastName"
                    name="lastName"
                    bind:value={newAdmin.lastName}
                />
            </div>

            <div class="flex flex-col gap-y-2 flex-1">
                <div class="flex gap-x-4 items-center align-center">
                    <label class="w-1/3 text-right" for="email">Email</label>
                    <input
                        type="email"
                        required
                        class="input input-bordered input-sm flex flex-1"
                        id="email"
                        name="email"
                        bind:value={newAdmin.email}
                    />
                </div>

                {#if !isValidEmail}
                    <div class="flex gap-x-4 items-center align-center">
                        <label for="" class="w-1/3"></label>
                        <p class="text-error flex-1">Invalid E-mail</p>
                    </div>
                {/if}
            </div>

            <div class="flex flex-col gap-y-2 flex-1">
                <div class="flex gap-x-4 items-center align-center">
                    <label class="w-1/3 text-right" for="phone">Phone No.</label
                    >
                    <input
                        type="phone"
                        required
                        class="input input-bordered input-sm flex flex-1"
                        id="phone"
                        name="phone"
                        bind:value={newAdmin.phone}
                    />
                </div>

                {#if !isValidPhone}
                    <div class="flex gap-x-4 items-center align-center">
                        <label for="" class="w-1/3"></label>
                        <p class="text-error flex-1">Invalid Phone</p>
                    </div>
                {/if}
            </div>
        </div>

        <div class="divider lg:divider-horizontal" />

        <div class="flex flex-col flex-1 gap-y-4 h-auto">
            <div class="flex gap-x-4 items-start align-center">
                <label class="w-1/3 text-right pt-1" for="password">
                    Password
                </label>
                <PasswordInput bind:value={newAdmin.password} isRequired />
            </div>

            <div class="flex gap-x-4 items-start align-center">
                <label class="w-1/3 text-right pt-1" for="confirmPassword">
                    Confirm Password
                </label>

                <div class="flex flex-col flex-1 gap-y-2">
                    <PasswordInput
                        bind:value={newAdmin.confirmPassword}
                        pwdValue={newAdmin.password}
                        isConfirm
                        isRequired
                    />
                </div>
            </div>
        </div>
    </div>

    <div class="flex flex-1 items-center justify-end p-4 gap-4">
        <Button clickFunc={goBack} manualClass="w-[64px] btn-error">
            Cancel
        </Button>

        <Button
            clickFunc={createAdmin}
            manualClass={CreateButtonDisabled
                ? "w-[64px] text-primary"
                : "w-[64px]"}
            isDisabled={CreateButtonDisabled}
        >
            Create
        </Button>
    </div>
</CardLayout>
